<template>
  <div :style="{ width: width, height: height }" class="oss-image">
    <img v-lazy="imgUrl">
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: 'auto'
    },
    src: {
      type: String,
      default: null
    },
    styleName: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    imgUrl() {
      if (!this.src) return null
      return this.$ossImageUrl(this.src, this.styleName)
    }
  }
}
</script>

<style lang="scss">
.oss-image {
  > img {
    width:100%;
    max-height:100%;
  }
}
</style>
